import { useEffect, useRef } from 'react'
import { useAuthStore } from '@/store/auth-store'
import { useModal } from '@/components/Modal'
import { ModalTypes } from '@/components/Modal'

export const useShowEndOfShiftModal = () => {
    const { xUserShiftId, endOfShiftTime } = useAuthStore()
    const { openModal } = useModal()
    const endOfShiftReminderShown = useRef(false)

    useEffect(() => {
        if (!xUserShiftId || !endOfShiftTime) return
        const endOfShiftDate = new Date(endOfShiftTime)
        const endHour = endOfShiftDate.getHours()
        const endMinute = endOfShiftDate.getMinutes()

        const checkTimeInterval = setInterval(() => {
            const now = new Date()
            const currentHour = now.getHours()
            const currentMinute = now.getMinutes()

            // Calculate minutes until end of shift using local time
            const currentTotalMinutes = currentHour * 60 + currentMinute
            const endTotalMinutes = endHour * 60 + endMinute

            // Handle case where end time is on the next day
            const minutesRemaining =
                endTotalMinutes > currentTotalMinutes
                    ? endTotalMinutes - currentTotalMinutes
                    : 24 * 60 - currentTotalMinutes + endTotalMinutes

            // Show modal when there are 10 minutes remaining and it hasn't been shown yet
            if (minutesRemaining <= 10 && minutesRemaining > 0 && !endOfShiftReminderShown.current) {
                openModal(ModalTypes.endOfShiftModal)
                endOfShiftReminderShown.current = true
            }
        }, 60000)

        return () => clearInterval(checkTimeInterval)
    }, [xUserShiftId, endOfShiftTime, openModal])
}
